module.exports = __webpack_public_path__ + "static/img/RZ_pic06.d73f82f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/RZ_pic06.png
// module id = SegP
// module chunks = 5